// extracted by css-extract-rspack-plugin
export default {"cls1":"Carousel-cls1_GV-","cls2":"Carousel-cls2_jWY Carousel-cls1_GV-"};